import React, { useMemo } from "react";
import { addDays, startOfDay } from "date-fns";
import EADayCalendar from "../../shared/EADayCalendar/EADayCalendar";
import { CALENDAR_HORIZON_DAYS } from "../../shared/EADayCalendar/calendarAvailability";

interface IProps {
  exerciseName: string;
  getExercisesByDate: (date: Date, zone: string) => void;
  selectedDate: Date;
  /** false = daty z API jeszcze się ładują, nie wiemy w którym miesiącu są terminy */
  daysLoaded?: boolean;
  /** Czy użytkownik już wybrał dzień – bez tego selectedDate (domyślnie „dziś") nie jest zaznaczeniem. */
  hasSelection?: boolean;
  listaDat?: Date[];
  soldOutDates?: Date[];
}

const CalendarDayPicker: React.FC<IProps> = ({
  getExercisesByDate,
  selectedDate,
  exerciseName,
  daysLoaded = true,
  hasSelection = true,
  listaDat = [],
  soldOutDates = [],
}) => {
  const toDate = useMemo(() => addDays(startOfDay(new Date()), CALENDAR_HORIZON_DAYS - 1), []);

  return (
    <EADayCalendar
      selectedDate={selectedDate}
      hasSelection={hasSelection}
      daysLoaded={daysLoaded}
      toDate={toDate}
      disabledDates={listaDat}
      soldOutDates={soldOutDates}
      onSelect={(date) => getExercisesByDate(date, exerciseName)}
    />
  );
};

export default CalendarDayPicker;
